import { render } from "./LoginMobile.vue?vue&type=template&id=5d131c6a&scoped=true"
import script from "./LoginMobile.vue?vue&type=script&lang=js"
export * from "./LoginMobile.vue?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&id=5d131c6a&lang=scss&scoped=true"
import "./LoginMobile.vue?vue&type=style&index=1&id=5d131c6a&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d131c6a"]])

export default __exports__